let collapsibles = document.querySelectorAll(".collapsible-content .collection__content-wrapper .grid__item .accordion details")
collapsibles.forEach((collapsible, index )=>{
  collapsible.addEventListener("click", function(e) {
    e.preventDefault()
    if (collapsible.hasAttribute("open")) {
      collapsible.removeAttribute("open")
    } else {
      collapsible.setAttribute("open", "")
    }
    collapsibles.forEach((element, number)=>{
      if (number != index) {
        if (element.hasAttribute("open")) {
          element.removeAttribute("open")
        }
      }
    })
  });
})
